import { v4 as uuid } from "uuid";

export const tableHeadersUsersInfoModal = [
  { text: "Логин", width: 233, defaultWidth: 233, value: "login", isLink: true, isSorted: false, isHandle: true, id: uuid() },
  { text: "Дата", width: 233, defaultWidth: 233, value: "grantedDate", isLink: false, isSorted: false, isHandle: true, id: uuid() },
  { text: "Кем выдана", width: 236, defaultWidth: 236, value: "username", isLink: true, isSorted: false, isHandle: true, id: uuid() },
];
